import { j as r } from "../../../../jsx-runtime.BREq8dyb.js";
import { DataTargetType as m, DataSourceType as l } from "@decentriq/graphql/dist/enums";
import { memo as S } from "react";
import { S as f } from "../../../../index.BRz-o-Vs.js";
import s from "./components/SplickyInfo/SplickyInfo.js";
import a from "./components/S3Info/S3Info.js";
import e from "./components/PermutiveInfo/PermutiveInfo.js";
import x from "./components/MetaInfo/MetaInfo.js";
import j from "./components/GoogleDV360Info/GoogleDV360Info.js";
import p from "./components/GoogleCloudStorageInfo/GoogleCloudStorageInfo.js";
import I from "./components/GoogleAdManagerInfo/GoogleAdManagerInfo.js";
import t from "./components/AzureInfo/AzureInfo.js";
import d from "./components/AdformInfo/AdformInfo.js";
import g from "./components/SnowflakeInfo/SnowflakeInfo.js";
import k from "./components/SalesforceInfo/SalesforceInfo.js";
const T = S(({
  syncDirection: o,
  syncType: u
}) => ({
  [f.IMPORT]: {
    [l.Azure]: /* @__PURE__ */ r.jsx(t, { syncDirection: o }),
    [l.GoogleCloudStorage]: /* @__PURE__ */ r.jsx(p, { syncDirection: o }),
    [l.Permutive]: /* @__PURE__ */ r.jsx(e, { syncDirection: o }),
    [l.S3]: /* @__PURE__ */ r.jsx(a, { syncDirection: o }),
    [l.Salesforce]: /* @__PURE__ */ r.jsx(k, { syncDirection: o }),
    [l.Snowflake]: /* @__PURE__ */ r.jsx(g, { syncDirection: o }),
    [l.Local]: null,
    [l.Compute]: null,
    [l.Databricks]: null
  },
  [f.EXPORT]: {
    [m.Adform]: /* @__PURE__ */ r.jsx(d, { syncDirection: o }),
    [m.Azure]: /* @__PURE__ */ r.jsx(t, { syncDirection: o }),
    [m.GoogleAdManager]: /* @__PURE__ */ r.jsx(I, { syncDirection: o }),
    [m.GoogleCloudStorage]: /* @__PURE__ */ r.jsx(p, { syncDirection: o }),
    [m.GoogleDv_360]: /* @__PURE__ */ r.jsx(j, { syncDirection: o }),
    [m.Meta]: /* @__PURE__ */ r.jsx(x, { syncDirection: o }),
    [m.MicrosoftDsp]: null,
    [m.Permutive]: /* @__PURE__ */ r.jsx(e, { syncDirection: o }),
    [m.S3]: /* @__PURE__ */ r.jsx(a, { syncDirection: o }),
    [m.Splicky]: /* @__PURE__ */ r.jsx(s, { syncDirection: o }),
    [m.Sportradar]: null,
    [m.TradeDesk]: null,
    [m.GoogleAds]: null,
    [m.Snapchat]: null,
    [m.Tiktok]: null
  }
})[o][u]);
T.displayName = "DqDatasetSyncInfo";
export {
  T as default
};
//# sourceMappingURL=DqDatasetSyncInfo.js.map
